import { useEffect } from "react";

type ContentType = {
  heading?: string;
  text?: string;
  list?: ListType[];
};

type ListType = {
  subheading: string;
  text: string;
};

const tnc: ContentType[] = [
  {
    heading: "",
    text: 'Welcome to TechQilla! These Terms of Service ("Terms") govern your use of our website, services, and any related offerings provided by TechQilla ("Company," "we," "our," or "us"). By engaging with our services, you agree to comply with these Terms.',
  },
  {
    heading: "1. Definitions",
    list: [
      {
        subheading: "Client",
        text: "refers to any individual or entity that engages with TechQilla for marketing services.",
      },
      {
        subheading: "Services",
        text: "refer to all marketing, consulting, branding, and digital solutions provided by TechQilla.",
      },
      {
        subheading: "User",
        text: "refers to any visitor or user of TechQilla’s website and services.",
      },
      {
        subheading: "TechQilla",
        text: "is a marketing-focused company specializing in branding, digital strategies, content marketing, social media management, SEO, and business growth solutions tailored for international clients.",
      },
    ],
  },
  {
    heading: "2. Scope of Services",
    text: "TechQilla provides international marketing, branding, consulting, and digital services, including but not limited to content creation, performance marketing, paid advertising, search engine optimization, website development, and strategic consulting. All service agreements are subject to project-specific contracts outlining scope, timelines, deliverables, and payment terms.",
  },
  {
    heading: "3. Eligibility",
    text: "You must be at least 18 years old or have the legal authority to enter into a binding contract in your jurisdiction to use our services. By using TechQilla’s services, you confirm that you are legally eligible to engage with us.",
  },
  {
    heading: "4. Payments and Fees",
    list: [
      {
        subheading: "",
        text: "All payments must be made in USD or GBP, unless otherwise agreed in writing.",
      },
      {
        subheading: "",
        text: "Clients will receive an invoice detailing the scope and pricing of services before the commencement of work.",
      },
      {
        subheading: "",
        text: "Payments must be made within the agreed timeframe to avoid service disruption",
      },
      {
        subheading: "",
        text: "Late or missed payments may result in suspension or termination of services.",
      },
      {
        subheading: "",
        text: "All fees are non-refundable, except where explicitly stated in the contract.",
      },
    ],
  },
  {
    heading: "5. Intellectual Property Rights and Protection",
    list: [
      {
        subheading: "TechQilla’s IP:",
        text: "All content, designs, marketing materials, strategies, campaigns, and proprietary tools created by TechQilla remain our intellectual property until full payment is received. Unauthorized use of TechQilla’s proprietary materials will result in legal action.",
      },
      {
        subheading: "Client’s IP:",
        text: "Any pre-existing materials, brand assets, trademarks, or proprietary information provided by the client remain their intellectual property. TechQilla will not use, share, or distribute client-provided IP beyond the scope of the agreed services without written consent.",
      },
      {
        subheading: "Joint Work:",
        text: "In cases where intellectual property is co-developed, ownership rights will be specified in the contract. If no such specification exists, TechQilla retains ownership of all strategies and methodologies developed, while the client retains rights to the final deliverables.",
      },
      {
        subheading: "Use Restrictions:",
        text: "Clients may use the deliverables as agreed in their contract but may not resell, distribute, or modify them without our written consent.",
      },
    ],
  },
  {
    heading: "6. Confidentiality",
    list: [
      {
        subheading: "",
        text: "Both parties agree to maintain confidentiality regarding sensitive business information shared during the course of service provision.",
      },
      {
        subheading: "",
        text: "Confidential information shall not be disclosed to third parties without prior written consent unless required by law.",
      },
      {
        subheading: "",
        text: "TechQilla implements industry-standard security measures to protect client data and proprietary information.",
      },
    ],
  },
  {
    heading: "7. Limitation of Liability",
    list: [
      {
        subheading: "",
        text: "TechQilla shall not be held liable for indirect, incidental, or consequential damages arising from the use of our services, including but not limited to lost profits, data breaches, or business disruptions",
      },
      {
        subheading: "",
        text: "Our total liability for any claim related to services provided shall not exceed the amount paid by the client for the specific service in question.",
      },
      {
        subheading: "",
        text: "Clients acknowledge that digital marketing results may vary due to external factors beyond TechQilla’s control.",
      },
    ],
  },
  {
    heading: "8. Compliance with Laws",
    list: [
      {
        subheading: "",
        text: "Clients agree to comply with all applicable laws, including but not limited to the UK Consumer Rights Act 2015, the General Data Protection Regulation (GDPR) for UK and EU clients, the US Federal Trade Commission (FTC) guidelines, and the CAN-SPAM Act for digital marketing communications.",
      },
      {
        subheading: "",
        text: "TechQilla reserves the right to refuse or terminate services if a project violates legal or ethical standards, including fraudulent, misleading, or deceptive marketing practices.",
      },
    ],
  },
  {
    heading: "9. Termination",
    list: [
      {
        subheading: "",
        text: "Either party may terminate the service agreement with 30 days written notice.",
      },
      {
        subheading: "",
        text: "If a client terminates a project early, they are responsible for payment of completed work up to the termination date.",
      },
      {
        subheading: "",
        text: "TechQilla reserves the right to terminate services immediately if a client violates these Terms, engages in unlawful activity, or fails to make timely payments.",
      },
    ],
  },
  {
    heading: "10. Dispute Resolution",
    list: [
      {
        subheading: "",
        text: "US Clients: Any disputes shall be governed by the laws of Delaware, USA, and resolved through arbitration in accordance with the rules of the American Arbitration Association (AAA).",
      },
      {
        subheading: "",
        text: "UK Clients: Any disputes shall be governed by the laws of England and Wales and resolved in UK courts in accordance with the Arbitration Act 1996.",
      },
      {
        subheading: "",
        text: "In the event of a dispute, both parties agree to first attempt mediation before pursuing legal action.",
      },
    ],
  },
  {
    heading: "11. Changes to These Terms",
    text: "We may update these Terms periodically to reflect changes in our services, legal requirements, or industry standards. Continued use of our services after any updates constitutes acceptance of the revised Terms.",
  },
  {
    heading: "12. Contact Information",
    text: "If you have any questions or require clarification regarding these Terms, please contact us at:",
  },
  {
    text: "<a href='mailto:hello@techqilla.com'><span className='font-semibold'>Email:</span> hello@techqilla.com</a>",
  },
  {
    text: "<a href='https://techqilla.com'><span className='font-semibold'>Website:</span> https://www.techqilla.com/</a>",
  },
  {
    text: "By using TechQilla’s services, you acknowledge and agree to these Terms of Service.",
  },
];
const TermAndCondition = () => {
  useEffect(() => {
    // Set Page Title
    document.title = "Terms of Service | TechQilla";

    // --- Description ---
    let metaDescription = document.querySelector<HTMLMetaElement>(
      "meta[name='description']",
    );
    if (!metaDescription) {
      metaDescription = document.createElement("meta");
      metaDescription.name = "description";
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute(
      "content",
      "Review the terms of service governing the use of TechQilla’s website, services, and digital solutions.",
    );

    // --- Keywords ---
    let metaKeywords = document.querySelector<HTMLMetaElement>(
      "meta[name='keywords']",
    );
    if (!metaKeywords) {
      metaKeywords = document.createElement("meta");
      metaKeywords.name = "keywords";
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.setAttribute("content", "Terms of Service");
    // --- Canonical ---
    let linkTag = document.querySelector<HTMLLinkElement>(
      "link[rel='canonical']",
    );
    if (!linkTag) {
      linkTag = document.createElement("link");
      linkTag.rel = "canonical";
      document.head.appendChild(linkTag);
    }
    linkTag.setAttribute("href", "https://www.techqilla.com/terms-of-services");
  }, []);

  return (
    <div className="max-w-screen-2xl mx-auto px-5 sm:px-20 py-8 sm:py-28">
      <div className="py-4 sm:py-6 px-4 sm:px-6 lg:px-8 font-montserrat">
        {/* <Markdown rehypePlugins={[rehypeRaw]}>{ termContext?.privacyContent.tnc}</Markdown> */}
        <h1 className="font-montserrat font-bold text-5xl mb-8">
          Terms of Services
        </h1>
        {tnc.map((term) => (
          <div className="">
            {term.heading && (
              <h3 className="font-bold font-montserrat text-2xl mb-2 mt-2">
                {term.heading}
              </h3>
            )}
            <div>
              {term.text && (
                <p
                  className="mb-2"
                  dangerouslySetInnerHTML={{
                    __html: term.text.replaceAll("className", "class"),
                  }}
                ></p>
              )}
              {term.list && (
                <ul className="list-disc ml-8">
                  {term.list.map((li) => (
                    <li>
                      {li.subheading} <span>{li.text}</span>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TermAndCondition;
